/* eslint-disable no-prototype-builtins */

// Configuratie-instellingen - PAS DEZE WAARDES AAN NAAR BEHOEFTE
const CONFIG = {
  // Minimum tijd in milliseconden voordat de popup wordt getoond
  popupDelay: 2000,

  // Prefix voor de kortingscode
  codePrefix: 'SALE',

  // Aantal karakters in de willekeurige deel van de code
  codeLength: 6,

  // URL van de Google Sheets Web App (zie uitleg onder)
  sheetsWebAppUrl: 'https://script.google.com/macros/s/AKfycbzKW2xYXYYUqtofoKI68qJACPXYMWy11XDQnNekh3Hi3JP99Y8eVIVAxwnfXaRi2DCl/exec',

  // Naam van de localStorage sleutel voor opslag
  storageKey: 'discountCodes',
};

// Functie om te controleren of er een gclid in de URL staat
function getGclidFromUrl() {
  // Voor JSFiddle test: Forceer een gclid waarde
  // return "test123";

  // In productie gebruiken:
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('gclid');
}

// Functie om een willekeurige code te genereren
function generateRandomCode() {
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Geen verwarrende karakters zoals I, 1, O, 0
  let result = CONFIG.codePrefix + '-';

  for (let i = 0; i < CONFIG.codeLength; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
}

// Functie om te controleren of deze gclid al een kortingscode heeft gekregen
function hasCodeBeenIssuedForGclid(gclid) {
  const savedCodes = getStoredCodes();
  return savedCodes.hasOwnProperty(gclid);
}

// Functie om kortingscodes op te halen uit localStorage
function getStoredCodes() {
  const storedCodes = localStorage.getItem(CONFIG.storageKey);
  return storedCodes ? JSON.parse(storedCodes) : {};
}

// Functie om nieuwe kortingscode op te slaan
function storeDiscountCode(gclid, code) {
  const savedCodes = getStoredCodes();
  savedCodes[gclid] = {
    code: code,
    shown: false, // Nieuw: popup nog niet getoond
  };
  localStorage.setItem(CONFIG.storageKey, JSON.stringify(savedCodes));
}

// Functie om kortingscode naar Google Sheets te sturen
function sendToGoogleSheets(gclid, code) {
  console.log(`Versturen naar Google Sheets: gclid=${gclid}, code=${code}`);

  // Bereid de data voor om naar Google Sheets te sturen
  const data = {
    gclid: gclid,
    discountCode: code,
    timestamp: new Date().toISOString(),
  };

  console.log('Data die verzonden wordt:', JSON.stringify(data));

  // Stuur data naar Google Sheets Web App via fetch API
  fetch(CONFIG.sheetsWebAppUrl, {
    method: 'POST',
    mode: 'no-cors', // Dit is belangrijk voor cross-domain requests
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      console.log('Response ontvangen:', response);
      console.log('Data succesvol verzonden naar Google Sheets');
    })
    .catch((error) => {
      console.error('Fout bij het verzenden naar Google Sheets:', error);
    });
}

// Functie om popup te openen
function openPopup() {
  document.getElementById('discountPopup').style.display = 'block';
}

// Functie om popup te sluiten
function closePopup() {
  document.getElementById('discountPopup').style.display = 'none';
}

// Functie om localStorage te wissen (voor testen)
function resetStorage() {
  localStorage.removeItem(CONFIG.storageKey);
  console.log('LocalStorage gewist voor testen');
}

// Hoofdfunctie om het proces te starten
function initDiscountPopup() {
  // Controleer of er een gclid in de URL staat
  const gclid = getGclidFromUrl();

  if (!gclid) {
    console.log('Geen gclid parameter gevonden in de URL');
    return; // Stop als er geen gclid is
  }

  console.log(`GCLID gevonden: ${gclid}`);

  const savedCodes = getStoredCodes();
  const gclidData = savedCodes[gclid];
  let discountCode;

  // Check of code al is uitgegeven
  if (gclidData) {
    discountCode = gclidData.code;

    // Check of popup al is getoond
    if (gclidData.shown) {
      console.log('Popup is al getoond voor deze gclid');
      return;
    }

    console.log('Bestaande kortingscode gevonden voor deze gclid');
  }
  else {
    // Genereer nieuwe code
    discountCode = generateRandomCode();

    // Sla de code op met shown = false
    savedCodes[gclid] = {
      code: discountCode,
      shown: false,
    };
    localStorage.setItem(CONFIG.storageKey, JSON.stringify(savedCodes));

    // Stuur naar Google Sheets
    sendToGoogleSheets(gclid, discountCode);

    console.log('Nieuwe kortingscode gegenereerd en verzonden');
  }

  // Update de popup met de code
  document.getElementById('discountCode').textContent = discountCode;

  // Toon de popup na vertraging en markeer als getoond
  setTimeout(() => {
    openPopup();

    // Markeer de code als getoond
    const updatedCodes = getStoredCodes();
    if (updatedCodes[gclid]) {
      updatedCodes[gclid].shown = true;
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(updatedCodes));
    }
  }, CONFIG.popupDelay);
}

// Start het proces zodra de pagina geladen is
// window.addEventListener('DOMContentLoaded', initDiscountPopup);
